<template>
	<div class="tableWrap">
		<div class="head">
			<span @click="goBack" class="back">
				<i>&nbsp;</i>返回</span>
			<span class="mx">BU预算明细</span>
			<p class="select">
				<el-date-picker class="top-choose" v-model="datePick_start" type="date" placeholder="选择日期" :picker-options="picker_special">
				</el-date-picker>
				<small>~</small>
				<el-date-picker class="top-choose" v-model="datePick_end" type="date" placeholder="选择日期" :picker-options="picker_special">
				</el-date-picker>
				<!-- <span>快币类型：</span>
				<el-select class="top-choose" v-model="currencyId" clearable placeholder="请选择">
					<el-option v-for="item in currencyList" :key="item.id"  :value="item.id" :label="item.currency_name" >
					</el-option>
				</el-select> -->
				<el-button type="primary" style="margin-left:20px;" @click="search()">查询</el-button>
			</p>
		</div>
		<div class="table-main">
			<div class="main-head">
				<div>日期</div>
				<!-- <div>快币类型</div> -->
				<div>预算收支({{ task_curr.currency_name }})</div>
				<div>预算余额({{ task_curr.currency_name }})</div>
				<div>详情</div>
			</div>
			<z-scrollDiv class="main-wrap">
				<div class="main-item" v-for="item in dataList" :key="item.id">
					<div>{{ item.bill_time }}</div>
					<!-- <div>{{ item.currency_name }}</div> -->
					<div :class="{add:item.bill_type == 1,reduce:item.bill_type!=1}">{{ calcStr(item) }}</div>
					<div>{{ item.balance }}</div>
					<div class="overhide" :title="item.remark">{{ item.remark }}</div>
				</div>
				<z-noData :list="dataList"></z-noData>
			</z-scrollDiv>
		</div>

		<z-pagination @getPage="search" :data='data'></z-pagination>
	</div>
</template>

<script type="text/ecmascript-6">
	import { mapState,mapGetters } from 'vuex'
	export default {
		data() {
			return {
				data:{},
				datePick_start:"",
				datePick_end:"",
				currencyId:"",  //快币类型id
			}
		},
		computed: {
			...mapState(["picker_special",'currencyList']),
			...mapGetters(['task_curr']),
			dataList(){
				return this.data.list;
			},
		},
		watch:{

		},

		created(){
			this.refresh();
			this.$func.getCurrencyList(true);   //获取快币列表
		},

		methods:{
			goBack: function () {  //回退和清数据
				this.$router.push({
					name:'info-money',
				});
			},

			refresh(obj={}){
				this.$http.get("api/manager/curr_bgt_detail",{params:obj}).then(res=>{
					if(res.status == 200){
						this.data = res.res_data;
						console.log(res.res_data);
					}
				});
			},
			search(page){
				let obj={
					page:page,
					start_date:this.datePick_start,
					end_date:this.datePick_end,
					currency_id:this.currencyId,
				}
				this.refresh(obj);
			},
			calcStr(item){  //拼接字符串
				let operator = item.bill_type == 1?"+":"-";
				let num = item.trans_amount;
				return operator+num;
			},
		}

	}
</script>

<style lang="less" scoped>
	@import "~src/assets/less/asset-detail.less";

	// **************
	.main-head,.main-item{
		>div{
			&:nth-of-type(1){
				width:18%;
			}
			&:nth-of-type(2){
				width:20%;
			}
			&:nth-of-type(3){
				width:20%;
			}
			&:nth-of-type(4){
				max-width: 40%;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// page-budgetTable.vue?3eea6530